import { render } from "./CurrentLeftMenu.vue?vue&type=template&id=3a4eb271"
import script from "./CurrentLeftMenu.vue?vue&type=script&lang=js"
export * from "./CurrentLeftMenu.vue?vue&type=script&lang=js"

import "./CurrentLeftMenu.vue?vue&type=style&index=0&id=3a4eb271&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__